export const HEADERS = {
    shipping_line : "Shipping Line",
    shipping_line_code : "Shipping Line Code",
    created_by : "Created By" ,
    created_on : "Created On" ,
    modified_by : "Modified By",
    modified_on : "Modified On" ,
    actions : "Edit/Delete"
}

export const TITLES = {
    main_title : "Shipping Line",
    add_title : "Add Shipping Line",
    edit_title : "Edit Shipping Line"
}
export const LABELS = {
    shipping_line_code : "Shipping Line Code",
    shipping_line : "Shipping Line"
}
export const PLACE_HOLDERS = {
    shipping_line_code : "Enter Shipping Line Code",
    shipping_line : "Enter Shipping Line"
}
export const BUTTONS = {
    submit : "Submit",
    cancel : "Cancel"
}